import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

interface SubscriptionTypeToIconMap {
  [key: string]: string,
}

export class TypeCell extends GridCell {
  private typesToIcons: SubscriptionTypeToIconMap = {
    Content: '',
    Lead: 'fas fa-star',
    Preferred: 'fas fa-plus',
    Sponsored: 'fas fa-dollar-sign',
  }

  public render() {
    const typeKey = this.props.dataItem.feature_type || this.props.dataItem.subscription_type
    return <td>
      <span title={typeKey}>
          <i className={this.typesToIcons[typeKey]}></i>
        </span>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/type_cell.tsx